import * as React from 'react';
export default () => (
  <svg
    width={25}
    height={25}
    viewBox='0 0 25 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.637 0.390625C5.94751 0.390625 0.527588 5.81055 0.527588 12.5C0.527588 19.1895 5.94751 24.6094 12.637 24.6094C19.3264 24.6094 24.7463 19.1895 24.7463 12.5C24.7463 5.81055 19.3264 0.390625 12.637 0.390625ZM12.637 5.07812C15.01 5.07812 16.9338 7.00195 16.9338 9.375C16.9338 11.748 15.01 13.6719 12.637 13.6719C10.2639 13.6719 8.34009 11.748 8.34009 9.375C8.34009 7.00195 10.2639 5.07812 12.637 5.07812ZM12.637 21.875C9.77075 21.875 7.20239 20.5762 5.48364 18.5449C6.40161 16.8164 8.19849 15.625 10.2932 15.625C10.4104 15.625 10.5276 15.6445 10.6399 15.6787C11.2747 15.8838 11.9387 16.0156 12.637 16.0156C13.3352 16.0156 14.0042 15.8838 14.634 15.6787C14.7463 15.6445 14.8635 15.625 14.9807 15.625C17.0754 15.625 18.8723 16.8164 19.7903 18.5449C18.0715 20.5762 15.5032 21.875 12.637 21.875Z'
      fill='#0077C8'
    />
  </svg>
);
